import { render, staticRenderFns } from "./ListWarrantyRejection.vue?vue&type=template&id=3c6dd580&scoped=true"
import script from "./ListWarrantyRejection.vue?vue&type=script&lang=js"
export * from "./ListWarrantyRejection.vue?vue&type=script&lang=js"
import style0 from "./ListWarrantyRejection.vue?vue&type=style&index=0&id=3c6dd580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6dd580",
  null
  
)

export default component.exports